import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import Overview from "./views/Overview";
import About from "./views/About";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import TopicsOverviewSelectJunJuly from "./components/topics/TopicsOverviewJunJuly"
import TopicsOverviewSelectAugust from "./components/topics/TopicsOverviewAugust"
import TopicsOverviewSelectSeptember from "./components/topics/TopicsOverviewSepetember"
import TopicsOverviewSelectOctober from "./components/topics/TopicsOverviewOctober"
import TopicsOverviewSelectNovember from "./components/topics/TopicsOverviewNovember"
import TopicsOverviewSelectDecember from "./components/topics/TopicsOverviewDecember"
import TopicsOverviewSelectJanuary from "./components/topics/TopicsOverviewJanuary"
import TopicsOverviewTables from "./components/topics/TopicsOverviewTable"

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/overview" />
  },
  {
    path: "/overview",
    layout: DefaultLayout,
    component: Overview
  },
  {
    path: "/about",
    layout: DefaultLayout,
    component: About
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts
  },
  ,
  {
    path: "/June-and-July",
    layout: DefaultLayout,
    component: TopicsOverviewSelectJunJuly
  },
  {
    path: "/August",
    layout: DefaultLayout,
    component: TopicsOverviewSelectAugust
  },
  {
    path: "/September",
    layout: DefaultLayout,
    component: TopicsOverviewSelectSeptember
  },
  {
    path: "/October",
    layout: DefaultLayout,
    component: TopicsOverviewSelectOctober
  },
  {
    path: "/November",
    layout: DefaultLayout,
    component: TopicsOverviewSelectNovember
  },
  {
    path: "/December",
    layout: DefaultLayout,
    component: TopicsOverviewSelectDecember
  },
  {
    path: "/January",
    layout: DefaultLayout,
    component: TopicsOverviewSelectJanuary
  },
  {
    path: "/topics-table",
    layout: DefaultLayout,
    component: TopicsOverviewTables
  }
];
